import { render, staticRenderFns } from "./riderzc.vue?vue&type=template&id=2f70e420&"
import script from "./riderzc.vue?vue&type=script&lang=js&"
export * from "./riderzc.vue?vue&type=script&lang=js&"
import style0 from "./riderzc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports